"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePidgetInstance = void 0;
var react_1 = require("react");
var PidgetContext_1 = require("./PidgetContext");
var usePidgetInstance = function () {
    var context = react_1.useContext(PidgetContext_1.PidgetContext);
    if (context === null) {
        throw new Error("usePidgetInstance must be used within a PidgetProvider");
    }
    return { instanceId: context.pidget.instanceId };
};
exports.usePidgetInstance = usePidgetInstance;
